import { PaymentPanel } from 'go-modules/payment-panel/payment-panel.service';
import { LICENSE_TRANSACTION_TYPE, PAYMENT_TYPES, PURCHASE_TYPES } from 'go-modules/payment-panel/payment-panel.controller';
import { NgxFeatureFlagService } from '@go-modules/services/feature-flag/feature-flag.service';
import { DowngradeModalService } from '@go-modules/services/downgrade-modal/downgrade-modal.service';
import { NgxSelfPayService } from '@go-modules/services/self-pay';
import { SelectedService } from 'go-modules/services/selected/selected.service';
import { NgxGoToastService } from '@go-modules/services/go-toast/go-toast.service';
import { GoToastStatusType } from '@go-modules/enums/go-toast-status-type';
import { NgxCourseService } from '@go-modules/services/course/course.service';

/* @ngInject */
export class LicensePaymentWizardViewController  {
	public wizardController: any;
	public modalInstance: any;
	public isDestroyed: boolean = false;

	constructor (
		private Group,
		private $ocLazyLoad: oc.ILazyLoad,
		private appData,
		private $injector,
		private $element,
		private $scope,
		private $q: ng.IQService,
		private $log: ng.ILogService,
		private $window: ng.IWindowService,
		private ngxSelfPayService: NgxSelfPayService,
		private ngxDowngradeModalService: DowngradeModalService,
		private featureFlag: NgxFeatureFlagService,
		private selectedService: SelectedService,
		private ngxGoToastService: NgxGoToastService,
		private ngxCourseService: NgxCourseService
	) {}

	public $onInit () {
		// Dismiss the instance to remove this from $uibModalStack
		this.$scope.$on('$destroy', (): void => {
			this.modalInstance?.dismiss();
			this.isDestroyed = true;
		});

		let selectedProduct = null;

		let productSelectionPromise = this.$q.resolve();

		if (this.featureFlag.isAvailable('LICENSE_UPGRADE_PURCHASE')) {
			productSelectionPromise = this.$q((resolve, reject) => {
				this.ngxSelfPayService.getProducts(this.appData.org_id).subscribe({
					next: (products) => {
						this.ngxDowngradeModalService.openCompareProductsDialog({
							transactionType: LICENSE_TRANSACTION_TYPE.INITIAL,
							license: null,
							products
						}).afterClosed().subscribe((returnedProduct) => {
							selectedProduct = returnedProduct;
							resolve();
						});
					},
					error: () => {
						this.ngxGoToastService.createToast({
							type: GoToastStatusType.ERROR,
							message: 'common_unknown-error_message'
						});
						reject(new Error('LicensePaymentWizardView::productSelectionPromise'));
					}
				});
			});
		}

		productSelectionPromise.then(() => {
			const importPromise = this.$q.when(import(/* webpackChunkName: "PaymentPanel" */ 'go-modules/payment-panel'))
				.then((module: any) => {
					return this.$ocLazyLoad.load(module.paymentPanelModule);
				});

			return importPromise.then(() => {
				const paymentPanel: PaymentPanel = this.$injector.get('PaymentPanel');
				this.modalInstance = paymentPanel.open({
					user: this.appData.currentUser,
					group: this.appData.myAccount,
					type: PAYMENT_TYPES.CARD,
					purchaseType: PURCHASE_TYPES.LICENSE,
					licenseTransactionType: LICENSE_TRANSACTION_TYPE.INITIAL,
					license: null,
					ltiWizard: true,
					selectedProduct
				},
				false,
				' center-side-panel',
				this.$element[0].querySelector('.panel-body')
				);

				this.modalInstance.result
					.then((transaction) => {
						const selectedGroup = this.selectedService.getGroup();
						this.ngxCourseService.updateCourse({
							...selectedGroup,
							billing_entity_id: transaction.license.billing_entity_id,
							// properties already exist but endpoint expects them in course settings object
							course_settings: {
								start_date: selectedGroup.start_date ?? null,
								end_date: selectedGroup.end_date ?? null,
								product_id: null // need to null out product id when updating billing entity
							}
						}).subscribe((group) => {
							this.selectedService.setGroup(this.Group.model({
								...group,
								upload_limit: group.license.salesforce_license.upload_limit_mb
							}));
						});
					})
					.finally(() => {
						this.appData.prompts.setupCourse = false;
						this.$window.sessionStorage.setItem('appData', JSON.stringify(this.appData));

						if(!this.isDestroyed) {
							this.wizardController.next();
						}
					});
			});
		}).catch((error) => {
			this.$log.error(`Failed to lazy load PaymentPanel: ${error.message}`);
		});
	}
}
